import React, { useEffect } from "react";

import { Decimal } from "decimal.js";
import NumberInput from "./NumberInput";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props {
  /**
   * The decimal value of the percentage. The value of 20% should be 0.2
   */
  value: number
  onChange: (decimal: number) => void

  autoFocus?: boolean

  canBeNegative: boolean
  digitsAfterDecimalPoint: number

  error?: boolean
  enablePercentageLabel?: boolean
  onEsc?: () => void
  onEnter?: (newValue: number) => void

}

const toDecimalValue = (percentage: number): number => {
  const percentageAsDecimalType = new Decimal(percentage);

  const decimalValue = percentageAsDecimalType.div(new Decimal(100));

  return decimalValue.toNumber();
};

const PercentageInput = (props: Props) => {
  const semanticInputRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.autoFocus) {
      semanticInputRef.ref.current.focus();
    }
  }, []);

  // We use decimaljs, because multiplying or dividing by 100 can result in floating point errors
  // Internally we use values like 0.2 for 20%
  // But the user types in 20 for 20%

  const displayValue = new Decimal(props.value).mul(new Decimal(100)).toNumber();

  return <NumberInput
    innerRef={semanticInputRef.refSetter}
    value={displayValue}
    onChanged={(v) => { props.onChange(toDecimalValue(v.value)); }}
    decimalPoints={props.digitsAfterDecimalPoint}
    width={60}
    labelContent={props.enablePercentageLabel ? "%" : undefined}
    onEscPressed={props.onEsc}
    onEnterPressed={v => props.onEnter(toDecimalValue(v.value))}
    minValue={0}
    maxValue={100}
    error={props.error}
  />
};

export default PercentageInput;